export const BUFFER_DURATION_THRESHOLD = 300; // Adjust as needed
export const MAX_PACKET_DURATION_THRESHOLD = 100; // Time in ms to wait for new packets before processing buffer
export const NO_PACKET_TIMEOUT = 40; // Time in ms to wait for new packets before processing buffer
export const PACKET_INTERVAL_MS = 20; // Expected interval between packets in milliseconds
export const NO_OUTBOUND_PACKET_THRESHOLD = 200; // If no packets for 200ms, assume speech has stopped
export const MIC_INPUT_SAMPLE_RATE = 48000; // Sample rate for microphone input
export const MIC_INPUT_BUFFER_SIZE = 4096; // Buffer size for microphone input
export const INBOUND_CHUNK_SIZE = 160; // 20ms at 8000Hz
export const OUTBOUND_PACKET_SAMPLE_RATE = 8000;
